/**
 * 转换为枚举选项，便于select option组件遍历
 * @param entity 枚举
 * @param type 枚举类型
 */
export function enumOptions(entity, type) {
  return Object.entries(entity)
    .filter(() => type === 'string' || 'number')
    .map(([label, value]) => ({ label, value }));
}

/**
 * 字符串枚举反向映射
 * @param entity 枚举
 */
export function enumReverse(entity) {
  return (value) => Object.entries(entity).find(([, val]) => val === value)?.[0];
}
